import React, { useEffect } from 'react';
import { Card } from 'antd';
import SupplierPaymentList from '../../components/SupplierPayment/SupplierPaymentList';
import { useSupplierPayment } from '../../store/supplierPaymentContext';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const SupplierPaymentListPage: React.FC = () => {
    const { fetchSupplierPayments } = useSupplierPayment();
    const navigate = useNavigate();

    useEffect(() => {
        fetchSupplierPayments();
    }, []);

    const handleEdit = (payment: any) => {
        navigate(`/supplier-payments/form/${payment.id || payment._id}`);
    };

    return (
        <div style={{ padding: 16 }}>
            <Card title={t('supplierPaymentList')} variant="outlined">
                <SupplierPaymentList onEdit={handleEdit} />
            </Card>
        </div>
    );
};

export default SupplierPaymentListPage;
